import React, { FC } from 'react';

import { InputCheckbox } from '@nebo-team/vobaza.ui.inputs.input-checkbox/dist/input-checkbox';
import { TableCell } from './TableRow';

import styles from './styles.module.scss';
import { IColConfig } from 'src/models/IConfigurableList';

const TableHead: FC<any> = (props) => {
  const {
    cols,
    rowGridTemplate,
    selectable,
    isAllSelected,
    canChangeRowsSort,
    onClickCheckbox,
    withoutGap,
    onClickRow,
  } = props;

  return (
    <div
      className={styles.tableHead}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onClickRow && onClickRow('ALL', isAllSelected);
      }}
    >
      <div
        className={`${styles.tableRow} ${withoutGap ? styles.withoutGap : ''}`}
        style={{ gridTemplateColumns: rowGridTemplate }}
      >
        {canChangeRowsSort && <div></div>}
        {selectable && (
          <div className={styles.tableCol}>
            <div className={styles.checkboxWrapper}>
              <InputCheckbox
                label=""
                initialValue={isAllSelected}
                onChange={onClickCheckbox && onClickCheckbox('ALL')}
                variation="tabular"
              />
            </div>
          </div>
        )}
        {cols.map((col: IColConfig) => (
          <TableCell key={col.title}>{col.title || '—'}</TableCell>
        ))}
      </div>
    </div>
  );
};

export default TableHead;
